export function type(o) {
  if (o === null) return 'Null';
  if (o === undefined) return 'Undefined';
  if (Object.prototype.hasOwnProperty.call(o, 'type')) return o.type;
  return Object.prototype.toString.call(o).slice(8, -1);
}

// TODO: Create method
// export function derive(child, parent) {
// }

export function defaultTo(defaultValue, value) {
  return value === undefined || value === null || value === '' ? defaultValue : value;
}

export function defaultToEmptyStr(value) {
  return defaultTo('', value);
}
